module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-hills-8fad9073bc28433ed323dc5c1f2cbd4d.svg";